var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 55,
    viewBox: "0 0 149 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2643_56424)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2643_56424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2643_56424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.661 0H15.3613V54.0671H133.661V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2643_56424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2643_56424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 119,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.661 0H15.3613V54.0671H133.661V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2643_56424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.3363 27.7491C69.3363 30.9151 66.7934 33.2481 63.6731 33.2481C60.5525 33.2481 58.0098 30.9151 58.0098 27.7491C58.0098 24.5607 60.5525 22.25 63.6731 22.25C66.7934 22.25 69.3363 24.5607 69.3363 27.7491ZM66.8571 27.7491C66.8571 25.7706 65.3835 24.4169 63.6731 24.4169C61.9625 24.4169 60.489 25.7706 60.489 27.7491C60.489 29.7078 61.9625 31.0813 63.6731 31.0813C65.3835 31.0813 66.8571 29.7053 66.8571 27.7491Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.553 27.7491C81.553 30.9151 79.0103 33.2481 75.8898 33.2481C72.7694 33.2481 70.2266 30.9151 70.2266 27.7491C70.2266 24.5631 72.7694 22.25 75.8898 22.25C79.0103 22.25 81.553 24.5607 81.553 27.7491ZM79.0739 27.7491C79.0739 25.7706 77.6003 24.4169 75.8898 24.4169C74.1793 24.4169 72.7058 25.7706 72.7058 27.7491C72.7058 29.7078 74.1793 31.0813 75.8898 31.0813C77.6003 31.0813 79.0739 29.7053 79.0739 27.7491Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2618 22.5822V32.4548C93.2618 36.5158 90.8031 38.1745 87.8964 38.1745C85.1602 38.1745 83.5135 36.3918 82.8924 34.934L85.0508 34.059C85.4352 34.9539 86.377 36.0101 87.8939 36.0101C89.7545 36.0101 90.9075 34.892 90.9075 32.787V31.9961H90.821C90.266 32.663 89.1971 33.2457 87.8481 33.2457C85.0255 33.2457 82.4395 30.8506 82.4395 27.7689C82.4395 24.6648 85.0255 22.25 87.8481 22.25C89.1945 22.25 90.2635 22.8326 90.821 23.4797H90.9075V22.5847H93.2618V22.5822ZM91.0832 27.7689C91.0832 25.8325 89.757 24.4169 88.0696 24.4169C86.359 24.4169 84.9261 25.8325 84.9261 27.7689C84.9261 29.6854 86.359 31.0813 88.0696 31.0813C89.757 31.0813 91.0832 29.6854 91.0832 27.7689Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1426 16.7949V32.9103H94.7246V16.7949H97.1426Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.568 29.5586L108.492 30.8082C107.87 31.7031 106.374 33.2453 103.788 33.2453C100.581 33.2453 98.1855 30.8304 98.1855 27.7461C98.1855 24.476 100.601 22.2471 103.511 22.2471C106.44 22.2471 107.872 24.5181 108.341 25.7454L108.598 26.3701L101.052 29.4148C101.629 30.518 102.527 31.0809 103.788 31.0809C105.05 31.0809 105.926 30.4759 106.568 29.5586ZM100.644 27.5801L105.689 25.5396C105.412 24.8529 104.577 24.3743 103.594 24.3743C102.334 24.3743 100.581 25.4578 100.644 27.5801Z",
    fill: "#172342",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8574 26.3182V23.9853H56.9284C57.0073 24.3919 57.048 24.8728 57.048 25.3935C57.048 27.1439 56.5567 29.3083 54.9736 30.8504C53.4337 32.4124 51.4663 33.2455 48.8599 33.2455C44.029 33.2455 39.9668 29.4124 39.9668 24.7067C39.9668 20.001 44.029 16.168 48.8599 16.168C51.5324 16.168 53.4363 17.1895 54.8667 18.5208L53.1767 20.1671C52.1509 19.23 50.7612 18.501 48.8574 18.501C45.3297 18.501 42.5706 21.2704 42.5706 24.7067C42.5706 28.143 45.3297 30.9123 48.8574 30.9123C51.1455 30.9123 52.4487 30.0174 53.2836 29.2042C53.9606 28.5446 54.406 27.6025 54.5817 26.3158L48.8574 26.3182Z",
    fill: "#172342",
    fillOpacity: 0.6
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2643_56424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.345703)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2643_56424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.33,
    height: 54.33,
    fill: "white",
    transform: "translate(0.345703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.043655f4cdcdda4f43d5c017e3b7ee2a.svg";
export { ForwardRef as ReactComponent };